import { DO_NOT_USE_FaWrapper } from '../../../foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { forwardRef } from 'react';
import { IconContainer, FadeOutContainer, FadeOutSpacer, StyledOverflowTypography } from '../components/index.js';
import { SidebarMenuUserContainer, TextContainer } from './styled.js';
import { useSidebarMenu } from '../useSidebarMenu/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Tooltip } from '../../../dataDisplay/Tooltip/Tooltip/index.js';
import { Avatar } from '../../../dataDisplay/Avatar/components/Avatar.js';
import { AvatarLetter } from '../../../dataDisplay/Avatar/components/AvatarLetter.js';

var SidebarMenuUser = /*#__PURE__*/forwardRef(function (props, ref) {
  var userName = props.userName,
    companyName = props.companyName,
    minimizedTooltip = props.minimizedTooltip,
    onClick = props.onClick;
  var _useSidebarMenu = useSidebarMenu(),
    minimized = _useSidebarMenu.minimized;
  return /*#__PURE__*/jsx(Tooltip, {
    disabled: !minimized,
    title: minimizedTooltip,
    side: "right",
    children: /*#__PURE__*/jsxs(SidebarMenuUserContainer, {
      ref: ref,
      $active: false,
      $minimized: minimized,
      onClick: onClick,
      children: [/*#__PURE__*/jsx(IconContainer, {
        children: /*#__PURE__*/jsx(Avatar, {
          size: "md",
          children: /*#__PURE__*/jsx(AvatarLetter, {
            children: userName[0]
          })
        })
      }), /*#__PURE__*/jsx(FadeOutContainer, {
        $minimized: minimized,
        children: /*#__PURE__*/jsxs(FadeOutSpacer, {
          children: [/*#__PURE__*/jsxs(TextContainer, {
            children: [/*#__PURE__*/jsx(StyledOverflowTypography, {
              $lineHeight: "neutralized",
              $appearance: "300",
              $fontWeight: "semibold",
              $fontSize: "small",
              children: userName
            }), /*#__PURE__*/jsx(StyledOverflowTypography, {
              $lineHeight: "neutralized",
              $appearance: "200",
              $fontWeight: "regular",
              $fontSize: "tiny",
              children: companyName
            })]
          }), /*#__PURE__*/jsx(IconContainer, {
            children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, {
              icon: faChevronRight
            })
          })]
        })
      })]
    })
  });
});

export { SidebarMenuUser };
